// extracted by mini-css-extract-plugin
module.exports = {"container":"DataHistoryTab_container_OzrUx","emptyDataContainer":"DataHistoryTab_emptyDataContainer_1a1GZ","spinAround":"DataHistoryTab_spinAround_knJaQ"};